import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import S from 'StyledAccountCurrentBonus.js';
import { translation, formatMoney } from 'utilsHelper.js';
import { formatDate } from 'datesHelper.js';
import Loader from 'Loader.js';
import ModalOpacity from 'ModalOpacity.js';
import {
  setCurrentPage,
  fetchCreditBonusListByFilter,
  fetchCreditBonusListPending,
  fetchCreditBonusListFulfilled,
  fetchCreditBonusListFailure,
  manageCreditBonus,
} from 'accountBonusActions.js';
import { proccessFrontError } from 'errorActions.js';

class AccountCurrentBonus extends Component {
  state = {
    selectedOfferId: null,
    showConfirmationModal: false,
    showInfoModal: false,
    modalTitle: '',
    modalDescription: '',
    infoModalTitle: '',
    infoModalDescription: '',
    status: '',
  };

  componentDidMount = async () => {
    const { fetchCreditBonusListByFilter, processFrontError } = this.props;
    try {
      await fetchCreditBonusListByFilter();
    } catch (error) {
      processFrontError(error, 'AccountCurrentBonus.componentDidMount');
    }
  };

  setSelectedOfferId = (selectedOfferId) => {
    this.setState((prevState) => {
      return { ...prevState, selectedOfferId };
    });
  };

  setStatus = (status) => {
    this.setState((prevState) => {
      return { ...prevState, status };
    });
  };

  setInfoModalTextElements = (infoModalTitle, infoModalDescription) => {
    this.setState((prevState) => {
      return { ...prevState, infoModalTitle, infoModalDescription };
    });
  };

  setConfirmModalTextElements = (action) => {
    let modalTitle = '';
    let modalDescription = '';
    switch (action) {
      case 'activate':
        modalTitle = translation('account_bonus_activationTitle');
        modalDescription = translation('account_bonus_confirmActivate');
        break;
      case 'cancel':
        modalTitle = translation('account_bonus_cancellationTitle');
        modalDescription = translation('account_bonus_confirmCancel');
        break;
      case 'reject':
        modalTitle = translation('account_bonus_cancellationTitle');
        modalDescription = translation('account_bonus_confirmReject');
        break;
    }

    this.setState((prevState) => {
      return { ...prevState, modalTitle, modalDescription };
    });
  };

  toggleModal = (type) => {
    this.setState((prevState) => {
      return { ...prevState, [type]: !prevState[type] };
    });
  };

  renderBonusActionConfirmation = (offerId, status) => {
    this.setStatus(status);
    this.setConfirmModalTextElements(status);
    this.setSelectedOfferId(offerId);
    this.toggleModal('showConfirmationModal');
  };

  bonusActionAccept = async (offerId, action) => {
    const { manageCreditBonus } = this.props;

    try {
      await manageCreditBonus(offerId, action);
      this.toggleModal('showConfirmationModal');
      this.toggleModal('showInfoModal');

      this.setInfoModalTextElements('success', '');
    } catch (error) {
      this.toggleModal('showConfirmationModal');
      this.toggleModal('showInfoModal');

      this.setInfoModalTextElements('error', translation(error));
    }
  };

  render() {
    const {
      showInfoModal,
      showConfirmationModal,
      modalTitle,
      modalDescription,
      infoModalTitle,
      infoModalDescription,
      status,
      selectedOfferId,
    } = this.state;
    const { isPending, bonus, currencyCode } = this.props;
    const { data } = bonus.active;

    return (
      <S.AccountCurrentBonus className="account-current-bonus">
        {isPending ? (
          <Loader />
        ) : (
          <>
            <ModalOpacity
              isOpen={showConfirmationModal}
              showHeaderIcon={false}
              showHeaderTitle={true}
              toggleOpen={this.toggleModal.bind(this, 'showConfirmationModal')}
              title={modalTitle}
            >
              <S.ActivateModal>
                <S.Description>{modalDescription}</S.Description>
                <S.BtnsWrapper>
                  <S.ButtonAccept
                    onClick={this.bonusActionAccept.bind(this, selectedOfferId, status)}
                  >
                    {translation('common_accept')}
                  </S.ButtonAccept>
                  <S.ButtonCancel onClick={this.toggleModal.bind(this, 'showConfirmationModal')}>
                    {translation('common_cancel')}
                  </S.ButtonCancel>
                </S.BtnsWrapper>
              </S.ActivateModal>
            </ModalOpacity>

            <ModalOpacity
              isOpen={showInfoModal}
              showHeader={false}
              showHeaderIcon={false}
              showHeaderTitle={false}
              toggleOpen={this.toggleModal.bind(this, 'showInfoModal')}
            >
              <S.ModalInfo>
                <S.InfoTitle>{infoModalTitle}</S.InfoTitle>
                {infoModalDescription && (
                  <S.InfoDescription>{infoModalDescription}</S.InfoDescription>
                )}
              </S.ModalInfo>
            </ModalOpacity>

            <S.BonusListWrapper>
              {data.length > 0 ? (
                <S.BonusList>
                  {data.map((bonus) => {
                    const {
                      offerId,
                      nameKey,
                      assignedBonusAmount,
                      activationTime,
                      wageredPercent,
                      totalToWager,
                      leftToWager,
                      validTo,
                      offerPlayerInfo = {},
                    } = bonus;
                    const { imageUrl, rulesPageUrl } = offerPlayerInfo;
                    const bonusItem = (
                      <S.BonusItem key={offerId}>
                        <S.BonusHeader>
                          <S.BonusTitle data-translation={nameKey}>
                            {translation(nameKey)}
                          </S.BonusTitle>
                        </S.BonusHeader>

                        <S.BonusImageWrapper ratio={2}>
                          {imageUrl && <S.BonusImage src={imageUrl} />}
                        </S.BonusImageWrapper>

                        <S.BonusBody>
                          <S.BonusBox>
                            <S.BonusBoxTitle>
                              {translation('account_bonus_validFromDate')}
                            </S.BonusBoxTitle>
                            <S.BonusBoxValue>
                              {formatDate(activationTime, 'yyyy-MM-dd HH:mm')}
                            </S.BonusBoxValue>
                          </S.BonusBox>

                          <S.BonusBox>
                            <S.BonusBoxTitle>{translation('account_bonus_amount')}</S.BonusBoxTitle>
                            <S.BonusBoxValue>
                              {formatMoney(assignedBonusAmount)}&nbsp;{currencyCode}
                            </S.BonusBoxValue>
                          </S.BonusBox>

                          <S.BonusBox>
                            <S.BonusBoxTitle>
                              {translation('account_bonus_validToDate')}
                            </S.BonusBoxTitle>
                            <S.BonusBoxValue>
                              {formatDate(validTo, 'yyyy-MM-dd HH:mm')}
                            </S.BonusBoxValue>
                          </S.BonusBox>

                          <S.BonusBox>
                            <S.BonusBoxTitle>
                              {translation('account_bonus_totalToWager')}
                            </S.BonusBoxTitle>
                            <S.BonusBoxValue>
                              {formatMoney(totalToWager)}&nbsp;{currencyCode}
                            </S.BonusBoxValue>
                          </S.BonusBox>

                          <S.BonusBox>
                            <S.BonusBoxTitle>
                              {translation('account_bonus_wageredPercent')}
                            </S.BonusBoxTitle>
                            <S.BonusBoxValue>{wageredPercent}</S.BonusBoxValue>
                          </S.BonusBox>

                          <S.BonusBox>
                            <S.BonusBoxTitle>
                              {translation('account_bonus_leftToWager')}
                            </S.BonusBoxTitle>
                            <S.BonusBoxValue>
                              {formatMoney(leftToWager)}&nbsp;{currencyCode}
                            </S.BonusBoxValue>
                          </S.BonusBox>
                        </S.BonusBody>

                        <S.WageredPercent wageredPercent={wageredPercent} />

                        <S.BonusFooter>
                          <S.BonusRegulationLink
                            href={rulesPageUrl ? rulesPageUrl : '/'}
                            target="_blank"
                          >
                            {translation('account_bonus_regulationLink')}
                          </S.BonusRegulationLink>
                        </S.BonusFooter>
                      </S.BonusItem>
                    );
                    return bonusItem;
                  })}
                </S.BonusList>
              ) : (
                <S.NoResult>{translation('account_bonus_notFound')}</S.NoResult>
              )}
            </S.BonusListWrapper>
          </>
        )}
      </S.AccountCurrentBonus>
    );
  }
}

const mapStateToProps = ({
  AccountBonus: { isPending, error, startDate, endDate, activeTab, limit, bonus },
  Auth: {
    user: { currencyCode },
  },
}) => {
  return {
    error,
    isPending,
    startDate,
    endDate,
    activeTab,
    limit,
    bonus,
    currencyCode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentPage: bindActionCreators(setCurrentPage, dispatch),
    fetchCreditBonusListByFilter: bindActionCreators(fetchCreditBonusListByFilter, dispatch),
    fetchCreditBonusListPending: bindActionCreators(fetchCreditBonusListPending, dispatch),
    fetchCreditBonusListFulfilled: bindActionCreators(fetchCreditBonusListFulfilled, dispatch),
    fetchCreditBonusListFailure: bindActionCreators(fetchCreditBonusListFailure, dispatch),
    manageCreditBonus: bindActionCreators(manageCreditBonus, dispatch),
    processFrontError: bindActionCreators(proccessFrontError, dispatch),
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountCurrentBonus);
